<button mat-icon-button color="primary" (click)="openInNewTab()" matTooltip="Open in new tab">
  <mat-icon>launch</mat-icon>
</button>

